import { render, staticRenderFns } from "./ButtonClose.vue?vue&type=template&id=061f9dac&scoped=true&"
import script from "./ButtonClose.vue?vue&type=script&lang=js&"
export * from "./ButtonClose.vue?vue&type=script&lang=js&"
import style0 from "./ButtonClose.vue?vue&type=style&index=0&id=061f9dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f9dac",
  null
  
)

export default component.exports